import type { CSSProperties, ImgHTMLAttributes } from "react";
import { brandAssets } from "../assets/brand";

export type BrandIconName = keyof typeof brandAssets;

export interface BrandIconProps extends Omit<
  ImgHTMLAttributes<HTMLImageElement>,
  "src" | "alt"
> {
  name: BrandIconName;
  size?: number;
  alt?: string;
  style?: CSSProperties;
}

/** Renders a brand SVG asset by import URL — geometry stays in the SVG file. */
export default function BrandIcon({
  name,
  size = 24,
  alt = "",
  style,
  ...rest
}: BrandIconProps) {
  return (
    <img
      src={brandAssets[name]}
      alt={alt}
      width={size}
      height={size}
      draggable={false}
      style={{
        width: size,
        height: size,
        objectFit: "contain",
        display: "block",
        ...style,
      }}
      {...rest}
    />
  );
}
